module.exports = (el) => {
  const modal = $(el);
  const submitButton = modal.find('#updateUserBtn');
  const removeButton = modal.find('#removeUserBtn');
  const addNewButton = modal.find('#addUserBtn');
  const selectUser = modal.find('.select-user');
  const footer = modal.find('.modal-footer');
  const userForm = modal.find('#userForm');
  const makeOwnerContainer = modal.find('.make-owner-container');
  const invitationContainer = modal.find('.invitation-container');
  const inviteButton = modal.find('#sendInvite');
  const ownerButton = modal.find('#makeUserAccountOwner');

  const onUserAddedCallbacks = [];
  const onUserUpdatedCallbacks = [];
  const onUserDeletedCallbacks = [];

  let options = {};
  let idOrganization = null;

  modal.find('[name=language]').select2({
    placeholder: __('Select Language'),
    minimumResultsForSearch: -1
  });

  function getFormData() {
    const data = userForm.serializeJson();
    data.id = data.id > 0 ? data.id : null;

    return data;
  }

  function submitButtonClick(e) {
    $('.help-block').remove();
    modal.find('.form-group').removeClass('has-error');
    footer.loading();

    const userData = getFormData();
    $.post(editUserUrl, userData).done((data) => {
      const userId = userForm.find('[name=id]').val();

      if (parseInt(userId)) {
        toastr.success(__('User has been updated'), 'Success');
        fireCallbacks(onUserUpdatedCallbacks, userData);
      } else {
        toastr.success(__('User has been added'), 'Success');
        fireCallbacks(onUserAddedCallbacks);
      }

      loadOrganizationUsers(data.user.id);
    }).always(() => {
      footer.loading('reset');
    });
  }

  function loadEditUserFormData(idUser) {
    if (idUser === 'new') {
      idUser = 0;

      addNewUserForm();
    }

    if (idUser === 0) {
      userForm.clearForm();
      userForm.find('[name=id]').val('');
      userForm.find('[name=language]').val('en').change();

      return;
    }

    modal.find('.modal-title').html(__('Edit User'));
    toggleRemoveButton();
    toggleAddNewButton();

    userForm.loading();
    $.post(loadEditUserUrl, { idUser, idOrganization }, (data, b) => {
      const userData = data.formData;

      if (userData) {
        const formData = {
          ...userData,
          billing: userData.billing ? '1' : '0',
          owner: userData.owner ? '1' : '0',
          newsletter: userData.newsletter ? '1' : '0'
        };

        userForm.fillForm(formData);

        toggleMakeOwnerButton(!userData.billing && !userData.owner ? 'show' : 'hide');
        toggleInviteButton(!userData.billing ? 'show' : 'hide');
      }
    }).always(() => {
      userForm.loading('reset');
    });
  }

  function makeAccoutOwnerButtonEvent() {
    modal.find('#makeUserAccountOwner').click(function () {
      const btn = $(this);

      $.post(makeUserAccountOwnerUrl, {
        organizationUserId: btn.data('id-user')
      }, (data) => {
        toastr.success(__('User has been updated'), 'Success');
        btn.parent().parent().remove();
        modal.find('#user-billing').parent().parent().remove();
      }, 'json');
    });
  }

  function toggleUsers(status) {
    if (status === 'hide' || options.hideUsers) {
      modal.find('.users').hide();
    } else {
      modal.find('.users').show();
    }
  }

  function toggleRemoveButton(status) {
    if (status === 'hide' || options.hideRemoveButton) {
      removeButton.hide();
      removeButton.attr('disabled', true);
    } else {
      removeButton.show();
      removeButton.attr('disabled', false);
    }
  }

  function toggleMakeOwnerButton(status) {
    if (status === 'hide' || options.hideOwnerButton) {
      makeOwnerContainer.hide();
    } else {
      makeOwnerContainer.show();
    }
  }

  function toggleInviteButton(status) {
    if (status === 'hide' || options.hideInviteButton) {
      invitationContainer.hide();
    } else {
      invitationContainer.show();
    }
  }

  function toggleAddNewButton(status) {
    if (status === 'hide' || options.hideNewButton) {
      addNewButton.hide();
      addNewButton.attr('disabled', true);
    } else {
      addNewButton.show();
      addNewButton.attr('disabled', false);
    }
  }

  function loadOrganizationUsers(idUser, callback) {
    if (typeof loadOrganizationUsersUrl === 'undefined' || options.hideUsers) {
      loadEditUserFormData(idUser);
      return typeof (callback) === 'function' ? callback() : true;
    }

    const removeButton = modal.find('#removeUserBtn');
    const formContainer = modal.find('.form-container');
    const info = modal.find('.info');

    info.hide();

    $.post(loadOrganizationUsersUrl, {
      id: idOrganization
    }, (data) => {
      selectUser.html('');
      if (data.users && data.users.length) {
        removeButton.show();
        data.users.forEach((user) => {
          selectUser.append($('<option></option>')
              .attr('value', user.id)
              .text(`${user.user_name} (${user.email})`));
        });

        if (idUser === 'new') {
          addNewUserForm();
        } else {
          selectUser.val(idUser || data.users[0].id).change();
        }

        info.hide();
        formContainer.show();
        submitButton.show();
      } else {
        userForm.clearForm();

        removeButton.hide();
        info.show();
        submitButton.hide();
        formContainer.hide();
        selectUser.val(null).change();
      }

      selectUser.select2('destroy').select2({
        placeholder: __('Select User'),
        width: '100%',
        minimumResultsForSearch: -1
      });

      if (typeof callback === 'function') {
        callback(data);
      }
    });
  }

  function selectUserChange() {
    const id = parseInt($(this).val());

    loadEditUserFormData(id);
  }

  function removeButtonClick(e) {
    const formContainer = modal.find('.form-container');

    footer.loading();

    bootbox.confirm({
      title: 'Delete user',
      message: __('Do you want to delete selected user? This cannot be undone.'),
      buttons: {
        cancel: {
          label: `<i class="fa fa-times"></i> ${__('Cancel')}`,
          className: 'btn-default btn-dark'
        },
        confirm: {
          label: `<i class="fa fa-check"></i> ${__('Delete')}`,
          className: 'btn-danger btn btn-space'
        }
      },
      callback(result) {
        footer.loading('reset');

        if (result) {
          $.post(deleteUserUrl, getFormData(), () => {
            loadOrganizationUsers(null, (data) => {
              if (typeof data !== 'undefined' && typeof data.users !== 'undefined' && !data.users.length) {
                formContainer.hide();
              }

              toastr.success(__('User has been deleted'));

              fireCallbacks(onUserDeletedCallbacks);
            });
          });
        }
      }
    });

    e.preventDefault();
  }

  function addNewUserForm() {
    const newUser = selectUser.find('option[value=0]');
    const formContainer = modal.find('.form-container');
    const info = modal.find('.info');

    modal.find('.modal-title').html(__('Add User'));
    toggleRemoveButton('hide');
    toggleAddNewButton('hide');
    toggleMakeOwnerButton('hide');
    toggleInviteButton('hide');

    if (!newUser.length) {
      selectUser.append($('<option></option>')
          .attr('value', 0)
          .text(__('New User')));
    }

    selectUser.val(0).change();

    info.hide();
    formContainer.show();
    submitButton.show();
  }

  function addNewButtonClick(e) {
    addNewUserForm();

    e.preventDefault();
  }

  function inviteButtonClick(e) {
    const btn = $(this);
    const idUser = getFormData().id;

    bootbox.confirm({
      title: 'Send invitation',
      message: __('Do you want to send invitation to selected user?'),
      className: 'site-modal',
      buttons: {
        cancel: {
          label: `<i class="fa fa-times"></i> ${__('Cancel')}`,
          className: 'btn-default btn-dark'
        },
        confirm: {
          label: `<i class="fa fa-check"></i> ${__('Send Invitation')}`,
          className: 'submit-form-button btn btn-green btn-thick'
        }
      },
      callback(result) {
        if (result) {
          btn.loading();

          $.post(sendInvitationUrl, { idUser }, (data, b) => {
            toastr.success(__('Invitation has been sent'));
          }).always(() => {
            btn.loading('reset');
          });
        }
      }
    });
  }

  function ownerButtonClick() {
    const btn = $(this);
    const userId = getFormData().id;

    btn.loading();
    $.post(makeUserAccountOwnerUrl, { organizationUserId: userId }, (data) => {
      toastr.success(__('User has been updated'));

      loadEditUserFormData(userId);
      fireCallbacks(onUserUpdatedCallbacks, { ...getFormData(), owner: 1 });
    }, 'json').always(() => {
      btn.loading('reset');
    });
  }

  function onUserAdded(callback) {
    onUserAddedCallbacks.push(callback);
  }

  function onUserUpdated(callback) {
    onUserUpdatedCallbacks.push(callback);
  }

  function onUserDeleted(callback) {
    onUserDeletedCallbacks.push(callback);
  }

  function fireCallbacks(callbacks, data) {
    callbacks.forEach((callback) => {
      if (data) {
        callback(data);
      } else {
        callback();
      }
    });
  }

  function show(opts, callback) {
    options = opts;

    if (typeof options !== 'object') {
      options = {
        organizationId: null,
        userId: options
      };
    }

    if (options.organizationId) {
      idOrganization = options.organizationId;
    } else {
      idOrganization = null;
    }

    toggleUsers();
    toggleRemoveButton();
    toggleAddNewButton();

    loadOrganizationUsers(options.userId, () => {
      modal.find('input[name=idOrganization]').val(idOrganization);
      modal.modal('show');

      if (callback) {
        callback();
      }
    });
  }

  selectUser.select2({
    placeholder: __('Select User'),
    width: '100%',
    minimumResultsForSearch: -1
  });

  submitButton.click(submitButtonClick);
  addNewButton.click(addNewButtonClick);
  removeButton.click(removeButtonClick);
  selectUser.change(selectUserChange);
  inviteButton.click(inviteButtonClick);
  ownerButton.click(ownerButtonClick);

  return {
    show,
    onUserAdded,
    onUserUpdated,
    onUserDeleted
  };
};
